module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.dbb2f34a.webp";